import {
  forwardRef,
  InputHTMLAttributes,
  useImperativeHandle,
  useRef,
} from 'react';
import { Button } from '../button/button';
import styles from './quant.module.css';
import { ButtonTier } from '../button/button.types';
import { Icon } from '../svgs';
import classNames from 'classnames';

type NumberInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  includeLabel?: boolean;
};

export const Quant2 = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ min, max, includeLabel, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => inputRef.current!, []);

    const handleChange = (delta: number) => {
      if (!inputRef.current) return;

      const currentValue = parseFloat(inputRef.current.value) || 0;
      let newValue = currentValue + delta;

      if (typeof min === 'number') newValue = Math.max(newValue, min);
      if (typeof max === 'number') newValue = Math.min(newValue, max);

      // Manually trigger Formik onChange with a synthetic event
      if (props.onChange && props.name) {
        const syntheticEvent = {
          target: {
            name: props.name,
            value: newValue.toString(),
          },
        };
        props.onChange(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
      }
    };

    return (
      <div
        className={classNames(styles.quantity, {
          [styles['quantity--nolabel']]: !includeLabel,
        })}
      >
        {includeLabel && <label className={styles.qntLabel}>Qnt:</label>}
        <Button
          onClick={() => {
            handleChange(-1);
          }}
          tier={ButtonTier.Tertiary}
          iconLeft={Icon.decreaseArrow}
          className={styles.decreaseButton}
        ></Button>
        <input {...props} ref={inputRef} type="number" />
        <Button
          onClick={() => {
            handleChange(+1);
          }}
          tier={ButtonTier.Tertiary}
          className={styles.increaseButton}
          iconRight={Icon.increaseArrow}
        ></Button>
      </div>
    );
  }
);
